export default "__VITE_ASSET__EDxr42B1__"